module.exports = __webpack_public_path__ + "img/crusher.5b70013f.png";